import {WindowParam} from "../../../library/context/WindowContext";
import {SizeAttr} from "../../../library/basic/size";
import {
    getOfficialBottomHeight,
    getOfficialInnerSectionWidth,
    getTopNavHeight,
    isSizeRangePcOrPcFull,
    isSizeRangePhone
} from "../compose/sizeRange";
import {BoxAttr, ColumnAttr, RowAttr} from "../../../library/basic/compose";
import {RowUnit} from "../../../library/atomic/unit/RowUnit";
import {BoxUnit, heightGap} from "../../../library/atomic/unit/BoxUnit";
import {ColumnUnit} from "../../../library/atomic/unit/ColumnUnit";
import {SpanText} from "../../../library/atomic/text/SpanText";
import {FontAttr} from "../../../library/basic/font";
import {ImageUnit} from "../../../library/atomic/image/ImageUnit";
import androidCode from "../../../assets/official/download/android-apk-download.png";
import iosCode from "../../../assets/official/apple-download.png";
import miniProgramCode from "../../../assets/official/download/miniprogram-qrcode.png";
import downloadIcon from "../../../assets/official/office-home-download-icon.svg";
import {detectAndroidBrand, isAndroid, isIOS} from "../../../library/util/userAgentUtil";
import {getAndroidAppLink, toAndroidDownloadPage, toIosDownloadPage} from "../compose/officeLinkUtil";
import BottomFooter from "./BottomFooter";

export function DownloadBox(wp: WindowParam) {
    let bottomHeight = getOfficialBottomHeight(wp)
    let bottomHeightNum = SizeAttr.getPxNumber(bottomHeight)

    let topNavHeight = SizeAttr.getPxNumber(getTopNavHeight(wp))
    let sectionHeightNum = wp.currHeight - topNavHeight >= 540 ? wp.currHeight - topNavHeight : 540

    let isHonorOrOppo = detectAndroidBrand() == "honor" || detectAndroidBrand() == "oppo"

    return (
        <ColumnUnit sizeAttr={new SizeAttr(wp, "100vw", sectionHeightNum + "px")}>
            <BoxUnit
                sizeAttr={new SizeAttr(wp, "100vw", (sectionHeightNum - bottomHeightNum) + "px")}>
                <ColumnUnit
                    fontAttr={new FontAttr(wp, "", "", "\"SongTi Sc\"")}
                    sizeAttr={new SizeAttr(wp, getOfficialInnerSectionWidth(wp))}
                    customStyleAttr={BoxAttr.getChildrenPositionObj()}>

                    {
                        isSizeRangePhone(wp) &&
                        <SpanText
                            customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                                "marginBottom": "4px"
                            })}
                            fontAttr={new FontAttr(wp, isSizeRangePhone(wp) ? "23px" : "31px", "600")}>
                            {"下载「信风Flow APP」"}
                        </SpanText>
                    }
                    <SpanText
                        customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                            "marginBottom": isSizeRangePhone(wp) ? "68px" : "72px"
                        })}
                        fontAttr={new FontAttr(wp, isSizeRangePhone(wp) ? "23px" : "31px", "600")}>
                        {isSizeRangePhone(wp) ? "智能心理咨询" : "下载「信风Flow APP」，智能心理咨询"}
                    </SpanText>

                    {
                        !isSizeRangePhone(wp) &&
                        <RowUnit
                            customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                                "marginBottom": "42px"
                            })}
                            sizeAttr={new SizeAttr(wp, SizeAttr.pxMultiple(getOfficialInnerSectionWidth(wp), isSizeRangePcOrPcFull(wp) ? 0.7 : 0.84))}>
                            {/*{downloadCodeCol(wp, androidCode, "安卓客户端下载", ColumnAttr.getChildrenPositionObj())}*/}
                            {downloadCodeCol(wp, iosCode, "苹果客户端下载", ColumnAttr.getChildrenPositionObj())}
                            {/*{downloadCodeCol(wp, miniProgramCode, "扫码体验小程序版")}*/}
                        </RowUnit>
                    }

                    {
                        isSizeRangePhone(wp) &&
                        <ColumnUnit
                            customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                                "marginBottom": "18px"
                            })}>

                            {isAndroid() && isHonorOrOppo &&
                                <SpanText customStyleAttr={{
                                    "marginLeft": "auto",
                                    "marginRight": "auto",
                                    "marginBottom": "24px",
                                    "fontSize": "16px"
                                }}>
                                    {"打开应用市场，搜索 “信风Flow”"}
                                </SpanText>
                            }

                            {!isIOS() && downloadButton(wp, downloadIcon,
                                (isAndroid() && getAndroidAppLink() != "") ? "前往应用市场" : (isHonorOrOppo ? "直接下载" : "下载安卓版"),
                                () => {
                                    toAndroidDownloadPage()
                                })}

                            {!isAndroid() && downloadButton(wp, downloadIcon, "前往AppStore", () => {
                                toIosDownloadPage()
                            })}

                            {/*{heightGap(wp, "32px")}*/}
                            {/*{downloadCodeCol(wp, miniProgramCode, "扫码体验小程序版")}*/}
                        </ColumnUnit>
                    }

                </ColumnUnit>
            </BoxUnit>
            {/*{BottomFooter(wp)}*/}
        </ColumnUnit>
    )
}

function downloadCodeCol(wp: WindowParam, code: string, text: string, cusObj?: {}) {
    let codeSize = "144px"
    let textSize = "20px"

    if (wp.currWidth > 600 && wp.currWidth <= 640) {
        codeSize = "88px"
        textSize = "15px"
    } else if (wp.currWidth <= 760) {
        codeSize = "108px"
        textSize = "18px"
    }

    return (
        <ColumnUnit customStyleAttr={Object.assign({}, cusObj)}>
            <ImageUnit
                customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                    "marginBottom": "18px"
                })}
                sizeAttr={new SizeAttr(wp, codeSize, codeSize)}
                url={code}/>
            <SpanText
                fontAttr={new FontAttr(wp, textSize, "600")}
                customStyleAttr={ColumnAttr.getChildrenPositionObj()}>
                {text}
            </SpanText>
        </ColumnUnit>
    )
}

function downloadButton(wp: WindowParam, icon: string, text: string, onClick: () => void,
                        width: string = "178px", backgroundColor: string = "#0EE3CA7C") {
    return (
        <RowUnit
            needHover={true}
            customStyleAttr={{
                "marginLeft": "auto",
                "marginRight": "auto",
                "borderRadius": "17px",
                "border": "1px solid black",
                "backgroundColor": backgroundColor,
                "boxShadow": "0 3px 2px rgba(0, 0, 0, 0.25)",
                "marginBottom": "24px"
            }}
            fontAttr={new FontAttr(wp, "18.5px", "500", "\"Helvetica Neue\"")}
            sizeAttr={new SizeAttr(wp, width, "34px")}
            onClick={() => {
                onClick()
            }}
        >
            <ImageUnit
                url={icon}
                sizeAttr={new SizeAttr(wp, "16px")}
                customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                    "marginLeft": "20px",
                    "marginRight": "16px"
                })}
            />
            <SpanText
                fontAttr={new FontAttr(wp, "14px")}
                customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                    "marginRight": "auto",
                    "letterSpacing": "0.6px",
                })}>
                {text}
            </SpanText>
        </RowUnit>
    )
}